// theme.ts
import {
    createTheme,
    colorsTuple,
    DEFAULT_THEME,
    mergeMantineTheme,
    virtualColor
} from '@mantine/core';

const themeOverride = createTheme({
    fontFamily: 'Montserrat, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    colors: {
        'yenta-blue': [
            '#84b0c8', '#6ba0bd', '#5290b2', '#3980a7', '#21709c', // lighter
            '#086091', '#075683', '#064d74', '#064366', '#053a57', // darker
        ],
        'yenta': [
            '#84b0c8', '#6ba0bd', '#5290b2', '#3980a7', '#21709c', // lighter
            '#086091', '#075683', '#064d74', '#064366', '#053a57', // darker
        ],
        'yenta-light-blue': colorsTuple('#B9DCF4'),
        'active-dark': colorsTuple('#054161'),
        'active-light': colorsTuple('#C5EAFC'),
        'active-background': virtualColor({
            name: 'active-background',
            dark: 'active-dark',
            light: 'active-light'
        }),
    },
    primaryColor: 'yenta-blue',
    defaultRadius: 0,
    autoContrast: true
});

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);